import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {Box, ThemeProvider } from '@mui/material';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function RaiseIndent(props){

  const [drugitems, setdrugItems] = useState([]);
  const [drugrows, setdrugrows] = useState([{ id: '', product: '', qty:''}]);
  const [registerFormData, setRegisterFormData] = useState({
        "dept":'',
        "user":'',
        "status":'',
        "product":'',
        "qty":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchPharmData();
  }, []);

  function fetchPharmData(page = 1, pageSize = 5000) {
    axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy&page=${page}&page_size=${pageSize}`)
      .then((pharmResponse) => {
        setdrugItems(pharmResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


  const handleKeyDowndrug = (e, index) => {
      const newdrugrows = [...drugrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === drugrows.length - 1) {
            newdrugrows.push({ id:'', product: '', qty:''});
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newdrugrows[index].selectedItemdrug === 0) {
            newdrugrows[index].selectedItemdrug = drugitems.length - 1;
          } else {
            newdrugrows[index].selectedItemdrug--;
          }
          setdrugrows(newdrugrows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newdrugrows[index].selectedItemdrug === drugitems.length - 1) {
            newdrugrows[index].selectedItemdrug = 0;
          } else {
            newdrugrows[index].selectedItemdrug++;
          }
          setdrugrows(newdrugrows);
          break;
        default:
          break;
      }
      setdrugrows(newdrugrows);
    };

  const handleSelectdrug = (val, index, id) => {
    const selectedItemdrug = val;
     if (!selectedItemdrug) {
        console.log('Selected item not found');
        return;
    }
    const newdrugrows = [...drugrows];
    newdrugrows[index] = {
      id: selectedItemdrug.id,
      product: selectedItemdrug.product.product,
      qty:'',
    };
    setdrugrows(newdrugrows);
  };

  const handleAddRowdrug = () => {
    const newdrugrows = [...drugrows];
    newdrugrows.push({ id:'', product: '', qty: ''});
    setdrugrows(newdrugrows);
  };

  const inputdrugRefs = useRef([]);

  useEffect(() => {
      inputdrugRefs.current[inputdrugRefs.current.length - 1]?.focus();
  }, [drugrows.length]);

  const handleDeleteRowdrug = (index) => {
    const newdrugrows = [...drugrows];
    newdrugrows.splice(index, 1);
    setdrugrows(newdrugrows);
  };

  const handledrugChange = (event, index) => {
    const { name, value } = event.target;
    const newdrugrows = [...drugrows];
    newdrugrows[index][name] = value;

    const selectedItem = drugitems.find(item => item.id === newdrugrows[index].id);
      if (selectedItem && Number(newdrugrows[index].qty) > selectedItem.totqty) {
        Swal.fire('Error', 'Quantity cannot exceed the available total quantity.', 'error');
        newdrugrows[index].qty = selectedItem.totqty; // Reset the quantity field
      }

    setdrugrows(newdrugrows);
  };

   const submitHandler = (e) => {
     e.preventDefault();
        const formData = new FormData();
        if (!registerFormData.dept) {
            Swal.fire('Error', 'Please select a Department.', 'error');
            return;
          }
        formData.append('dept',registerFormData.dept);
        formData.append('user',registerFormData.user);
        formData.append('status', 1);
        formData.append('product', drugrows.map(row => row.id).join(','));
        formData.append('qty', drugrows.map(row => row.qty).join(','));
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
        axios.post(baseUrl+'add-raise-indent/', formData)
        .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Raise Indent has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/raise-indent/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to Raise. Please try again later.',
                'error'
            );
          });
        };

 const inputHandler = (event) => {
    const { name, value } = event.target;
    const updatedRegisterFormData = { ...registerFormData, [name]: value };
    setRegisterFormData(updatedRegisterFormData);
 };
const customFilterOptions = (options, state) => {
    const inputValue = state.inputValue.toLowerCase();

    if (inputValue.length < 3) {
      return [];
    }

    const filteredOptions = options.filter(option => {
      const label = (option.label || option.product?.product || '').toLowerCase();
      return label.startsWith(inputValue);
    });

    return filteredOptions;
  };

return (
  <section className="container mt-4">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
      <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
      Raise Indent
    </h3>
    <div className="row">
    <div className="col-md-3 mb-3">
    <label htmlFor="Dept" className="form-label">Department</label>
    <select tabIndex={0} className="ms-2 me-3" name="dept" style={{ width: 200 }}
     onChange={inputHandler}
     value={registerFormData.dept}>
        <option >Choose Department</option>
        <option value="OT">OT</option>
        <option value="Emergency">Emergency</option>
        <option value="Labour">Labour</option>
        <option value="Dialysis">Dialysis</option>
        <option value="Ultrasound">Ultrasound</option>
        <option value="Radiology">Radiology</option>
        <option value="Fertility">Fertility</option>
    </select>
    </div>
    <div className="col-md-3 mb-3">
    <label htmlFor="Dept" className="form-label">Username</label>
    <div style={{ width: 200 }}>
      <input type="text" className="form-control" name="user" id="user" onChange={inputHandler} placeHolder="User"
      value={registerFormData.user}/>
    </div>
    </div>
    <form>
    <div className="table-responsive">
      <table className="erp-table-modern">
        <thead>
          <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
            <th style={{ width: 40 }}>ID</th>
            <th style={{ width: 300 }}>Drug name</th>
            <th style={{ width: 120 }}>QTY</th>
            <th style={{ width: 120 }}>Action</th>
          </tr>
        </thead>
      <tbody>

      {drugrows.map((row, index) => (
        <tr key={index}>
        <td>
          <input
            type="text"

            name="drug_id"
            tabIndex={-1}
            value={row.id}
            onChange={handledrugChange}
            readOnly
            style={{ width: 90 }}
          />
          </td>
               <td>
        <AutoComplete
          items={drugitems}
          options={drugitems}
          sx={{ width: 300 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDowndrug(e, index)}
          onChange={(event, val, id) => handleSelectdrug(val, index, id)}
          getOptionLabel={(option) => option ? option.product.product : ''}

           renderOption={(props, option) => (
              <Box component="li" {...props}
              fullWidth
              sx={{
              width: 750,
              height: 50,
              borderRadius: 1,
                }}
              >
                {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) Batch: ${option.product.batch}
                TQty: ${option.qty} ` : ''}
              </Box>

            )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps} fullWidth focused autoFocus
               style={{
                  background: "#F7EEFF",
                  width: 300,
                  }}
             />
            </div>
           )}
            filterOptions={customFilterOptions}
            ref={(el) => inputdrugRefs.current[index] = el}

           />
           </td>
           <td>
          <input
            type="number"
            className="ms-5 me-5"
            min={0}
            tabIndex={0}
            value={row.qty}
            name="qty"
            onChange={(e) => {
            const value = e.target.value;
            if (value >= 0) {
            handledrugChange(e, index)
            }
            }}
            onKeyDown={(e) => handleKeyDowndrug(e, index)}
            required
            style={{ width: 200 }}
          />
          </td>
          <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowdrug(index)}>Delete</button>
        </td>
        </tr>
      ))}
      </tbody>
      </table>
      </div>
      <button className="btn btn-success addmore mt-4"  type="button" onClick={handleAddRowdrug}>Add More</button>
      <div className="row">
        <div className="col-md-12 text-center mb-5">
          <button type="button" onClick={submitHandler} className="btn btn-success">Submit</button>
        </div>
      </div>
    </form>
    </div>
  </section>
);

}

export default RaiseIndent;